// 导航词条：左侧地栏 / 命令面板 / 各页标题共用（自 common.ts 按域迁出）

export const zh = {
  newChat: '新会话',
  knowledgeBase: '知识库',
  library: '资源工坊',
  settings: '设置',
  navDashboard: '首页',
  navExperts: '能力包管理',
  navConsole: '系统管理',
  systemStatusLockedDesc: '管理控制台仅对管理员开放，包含系统状态、专家与模型、工具治理等实例级管理功能',
  navStats: '运行统计',
  loadMoreThreads: '加载更多会话',
}

export const en = {
  newChat: 'New Chat',
  knowledgeBase: 'Knowledge Base',
  library: 'Library',
  settings: 'Settings',
  navDashboard: 'Dashboard',
  navExperts: 'Capability Packs',
  navConsole: 'System',
  systemStatusLockedDesc: 'The management console is admin-only: system status, experts & models, tool governance and other instance-level settings',
  navStats: 'Run Stats',
  loadMoreThreads: 'Load more',
}

export const ja = {
  newChat: '新しいチャット',
  knowledgeBase: 'ナレッジベース',
  library: 'ライブラリ',
  settings: '設定',
  navDashboard: 'ダッシュボード',
  navExperts: '能力パック管理',
  navConsole: 'システム管理',
  systemStatusLockedDesc: '管理コンソールは管理者専用です。システム状態、エキスパートとモデル、ツールガバナンスなどのインスタンス設定を含みます',
  navStats: '実行統計',
  loadMoreThreads: 'さらに読み込む',
}
